import React from 'react';
import { whyUsCards, trustBadges } from '../mock';
import { Award, Users, Briefcase, BadgeCheck, ShieldCheck, TrendingUp, ChevronLeft, ChevronRight } from 'lucide-react';
import { SectionHeader } from './Services';

const iconMap = { Award, Users, Briefcase, BadgeCheck, ShieldCheck, TrendingUp };

const WhyUs = () => {
  return (
    <section className="relative py-20 md:py-28">
      <div className="squiggle-bg" />
      <div className="max-w-6xl mx-auto px-6 relative">
        <SectionHeader
          eyebrow="Why Choose Us"
          title={<>Why Even <em className="italic">Us</em> ?</>}
          description="Because we don’t just teach — we place. India’s most trusted training partner for US taxation and Enrolled Agent certification."
        />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {whyUsCards.map((c, i) => {
            const Icon = iconMap[c.icon];
            return (
              <div key={i} className="card-soft rounded-2xl p-7 md:p-8 hover:-translate-y-1 transition-transform duration-300">
                <div className="w-12 h-12 rounded-xl bg-[#e6e0cf] flex items-center justify-center mb-6">
                  {Icon && <Icon size={22} className="text-[#143324]" strokeWidth={1.6} />}
                </div>
                <h3 className="font-body font-semibold text-[#143324] text-xl md:text-2xl mb-3">{c.title}</h3>
                <p className="text-[#3d3d3d] text-[14px] leading-relaxed font-body">{c.description}</p>
                <div className="mt-8 flex items-center gap-2">
                  <span className="h-1 w-16 rounded-full bg-[#143324]/60" />
                  <span className="h-1.5 w-1.5 rounded-full bg-[#143324]/25" />
                  <span className="h-1.5 w-1.5 rounded-full bg-[#143324]/15" />
                </div>
              </div>
            );
          })}
        </div>

        <div className="mt-10 flex items-center justify-center gap-3">
          <button className="w-10 h-10 rounded-full border border-[#143324]/25 flex items-center justify-center hover:bg-[#143324]/5 transition-colors">
            <ChevronLeft size={18} className="text-[#143324]" />
          </button>
          <button className="w-10 h-10 rounded-full border border-[#143324]/25 flex items-center justify-center hover:bg-[#143324]/5 transition-colors">
            <ChevronRight size={18} className="text-[#143324]" />
          </button>
        </div>

        <div className="mt-16 border-t border-[#143324]/10 pt-8">
          <div className="flex flex-wrap items-center justify-center gap-x-10 gap-y-4">
            {trustBadges.map((b, i) => {
              const Icon = iconMap[b.icon];
              return (
                <div key={i} className="flex items-center gap-2 text-[#1c1c1c]">
                  {Icon && <Icon size={18} className="text-[#143324]" strokeWidth={1.6} />}
                  <span className="text-sm font-body">{b.label}</span>
                  {i < trustBadges.length - 1 && <span className="hidden md:inline text-[#143324]/25 ml-6">|</span>}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
